export enum CurrencyNameEnum {
  ars = 'currency.argentine_peso',
  aud = 'currency.australian_dollar',
  brl = 'currency.brazilian_real',
  bgn = 'currency.bulgarian_lev',
  cad = 'currency.canadian_dollar',
  xaf = 'currency.central_african_franc',
  cop = 'currency.colombian_peso',
  czk = 'currency.czech_koruna',
  cny = 'currency.chinese_yuan',
  clp = 'currency.chilean_peso',
  dkk = 'currency.danish_krone',
  egp = 'currency.egyptian_pound',
  eur = 'currency.euro',
  ghs = 'currency.ghanaian_cedi',
  gnf = 'currency.guinean_franc',
  hkd = 'currency.hong_kong_dollar',
  huf = 'currency.hungarian_forint',
  isk = 'currency.icelandic_krona',
  inr = 'currency.indian_rupee',
  idr = 'currency.indonesian_rupiah',
  ils = 'currency.israeli_shekel',
  jpy = 'currency.japanese_yen',
  kes = 'currency.kenyan_shilling',
  mwk = 'currency.malawian_kwacha',
  myr = 'currency.malaysian_ringgit',
  mxn = 'currency.mexican_peso',
  mad = 'currency.moroccan_dirham',
  nzd = 'currency.new_zealand_dollar',
  ngn = 'currency.nigerian_naira',
  nok = 'currency.norwegian_krone',
  php = 'currency.philippine_peso',
  pln = 'currency.polish_zloty',
  gbp = 'currency.pound_sterling',
  ron = 'currency.romanian_leu',
  rub = 'currency.russian_ruble',
  rwf = 'currency.rwandan_franc',
  std = 'currency.sao_tome_and_principe_dobra',
  sar = 'currency.saudi_riyal',
  sll = 'currency.sierra_leonean_leone',
  sgd = 'currency.singapore_dollar',
  zar = 'currency.south_african_rand',
  lkr = 'currency.sri_lankan_rupee',
  sek = 'currency.swedish_krona',
  chf = 'currency.swiss_franc',
  tzs = 'currency.tanzanian_shilling',
  thb = 'currency.thai_baht',
  try = 'currency.turkish_lira',
  ugx = 'currency.ugandan_shilling',
  usd = 'currency.us_dollar',
  aed = 'currency.uae_dirham',
  xof = 'currency.west_african_cfa_franc_bceao',
  zmw = 'currency.zambian_kwacha',
  rsd = 'currency.serbian_dinar',
  uah = 'currency.ukrainian_hryvnia',
  all = 'currency.albanian_lek',
  vnd = 'currency.vietnam_dong',
  pen = 'currency.peruvian_sol',
}
